import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { getSasToken } from "../../services/dms/dms-admin";
import Loader from "../common/Loader/Loader";

const CSVViewer = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const { fileName } = useParams();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const imgParam = decodeURIComponent(fileName);
        const fileToken = params.get('token');
        const newurl = `${imgParam}${fileToken}`;

        fetch(newurl).then(response => response.text())
            .then(text => {
                setLoading(true);
                const rows = text.trim().split('\n').map(row => row.split(','));
                let html = `
                    <html>
                        <head>
                            <title>CSV Table</title>
                            <style>
                                table { border-collapse: collapse; }
                                th, td { border: 1px solid black; padding: 4px; }
                            </style>
                        </head>
                        <body>
                        <h2>CSV Table</h2>
                    <table>
                `;

                rows.forEach((row, idx) => {
                    html += '<tr>';
                    row.forEach(cell => {
                        const safeCell = cell.replace(/</g, '&lt;');
                        html += idx === 0 ? `<th>${safeCell}</th>` : `<td>${safeCell}</td>`;
                    });
                    html += '</tr>';
                });

                html += `
                    </table>
                    </body>
                    </html>
                `;

                const blob = new Blob([html], { type: 'text/html' });
                const blobUrl = URL.createObjectURL(blob);
                setLoading(false);
                window.open(blobUrl, '_self');
            });

    }, [location, navigate]);

    return (
        <div>
            <Loader />
        </div>
    );
};

export default CSVViewer;
